import React from 'react';
import { Popover, PopoverProps, PopoverBody } from 'reactstrap';

import { FEATURES_LIST } from 'services/constants';

type PopoverMessageByFeature = {
    /* eslint-disable-next-line no-unused-vars */
    [key in FEATURES_LIST]?: string;
}

export const featureDescriptions: PopoverMessageByFeature = {
    [FEATURES_LIST.PORTFOLIO_COST_ANALYTICS]: 'Aggregate and analyze budget line cost benchmarks and spending histories across multiple projects.',
    [FEATURES_LIST.QUICK_ANALYTICS]: 'Compare portfolio cost and performance benchmarks by asset class, project type, geography and more.',
    [FEATURES_LIST.PORTFOLIO_VENDOR_ANALYTICS]: 'Aggregate and analyze vendors invoices, contracts, and change order data across multiple projects.',
    [FEATURES_LIST.GLOBAL_COST_FORECAST]: 'Aggregate actual and forecasted costs by budget line across a portfolio of projects.',
    [FEATURES_LIST.VENDOR_DIRECTORY]: `Have full visibility across your entire vendor base with Northspyre's Vendor Directory,
        a company-wide, live vendor database where your team can catalog key vendor insights.`,
    [FEATURES_LIST.PORTFOLIO_INVOICE_DATA_INDEX]:
        'Have full visibility of all of your portfolio’s invoices and manage invoices across all projects in a single view.',
    [FEATURES_LIST.PORTFOLIO_BUDGET_CATEGORIZATIONS]:
            'Have full visibility of all of your portfolio’s budget categorizations in a single view.',
    [FEATURES_LIST.DATA_INBOX_APPROVAL_WORKFLOW]: 'Upgrade today to enable Approval Workflows.',
};

export const PORTFOLIO_OR_ORGANIZATION_LVL_POPOVERS: PopoverMessageByFeature = {
    [FEATURES_LIST.PORTFOLIO_COST_ANALYTICS]: featureDescriptions[FEATURES_LIST.PORTFOLIO_COST_ANALYTICS],
    [FEATURES_LIST.PORTFOLIO_VENDOR_ANALYTICS]: featureDescriptions[FEATURES_LIST.PORTFOLIO_VENDOR_ANALYTICS],
    [FEATURES_LIST.QUICK_ANALYTICS]: featureDescriptions[FEATURES_LIST.QUICK_ANALYTICS],
    [FEATURES_LIST.GLOBAL_COST_FORECAST]: featureDescriptions[FEATURES_LIST.GLOBAL_COST_FORECAST],
    [FEATURES_LIST.VENDOR_DIRECTORY]: featureDescriptions[FEATURES_LIST.VENDOR_DIRECTORY],
    [FEATURES_LIST.PORTFOLIO_INVOICE_DATA_INDEX]: featureDescriptions[FEATURES_LIST.PORTFOLIO_INVOICE_DATA_INDEX],
    [FEATURES_LIST.PORTFOLIO_BUDGET_CATEGORIZATIONS]: featureDescriptions[FEATURES_LIST.PORTFOLIO_BUDGET_CATEGORIZATIONS],
    [FEATURES_LIST.DATA_INBOX_APPROVAL_WORKFLOW]: featureDescriptions[FEATURES_LIST.DATA_INBOX_APPROVAL_WORKFLOW],
};

export interface IProps {
    toggle: (arg?: any) => void;
    isOpen: boolean;
    placement?: PopoverProps['placement'];
    trigger?: string;
    target: string;
    feature: FEATURES_LIST;
    upgradeTier: string;
}

const FeatureTierPopover
 = ({
     toggle,
     isOpen,
     placement,
     trigger,
     target,
     feature,
     upgradeTier,
 }: IProps) => {
     const title = `You've reached a Northspyre ${upgradeTier} feature`;
     const message = PORTFOLIO_OR_ORGANIZATION_LVL_POPOVERS[feature];

     return (
         <Popover
             placement={placement}
             isOpen={Boolean(isOpen && title && !!message)}
             target={target}
             toggle={toggle}
             trigger={trigger}
             id={`${target}-popover`}
         >
             <PopoverBody>
                 <b>{title}</b>
                 <p className="my-2">{message}</p>
                 <span className="font-italic">
                     Contact your org admin for more details
                 </span>
             </PopoverBody>
         </Popover>
     );
 };

FeatureTierPopover.defaultProps = {
    placement: 'auto',
    trigger: 'focus',
};

export default FeatureTierPopover;
